import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import './MSTeamsAuthResult.css'; // reuse styles

const ZoomAuthResult = () => {
  const [searchParams] = useSearchParams();

  const { success, title, message, error } = useMemo(() => {
    const status = searchParams.get('status');
    const msg = searchParams.get('msg');
    const isSuccess = status && status.toLowerCase() === 'connected';

    if (isSuccess) {
      return {
        success: true,
        title: 'Zoom connected',
        message: 'Your Zoom account is linked. You can close this page and continue in Calendar Integrations.',
        error: null,
      };
    }

    const safeError = msg ? decodeURIComponent(msg) : 'We could not complete Zoom authentication.';
    return {
      success: false,
      title: 'Zoom connection failed',
      message: safeError,
      error: safeError,
    };
  }, [searchParams]);

  return (
    <div className="msteams-result-page">
      <div className="msteams-result-card">
        <div className="msteams-result-header">
          <div className={`msteams-result-icon ${success ? 'success' : 'error'}`}>
            {success ? '✓' : '!'}
          </div>
          <h2 className="msteams-result-title">{title}</h2>
        </div>
        <p className="msteams-result-message">{message}</p>
        <div className="msteams-result-actions">
          <button className="msteams-result-button" onClick={() => window.close()}>
            Close
          </button>
        </div>
        <div className="msteams-result-hint">
          {success
            ? 'Return to Calendar Integrations to sync meetings.'
            : 'Please retry connecting Zoom from Calendar Integrations.'}
        </div>
      </div>
    </div>
  );
};

export default ZoomAuthResult;

